import axios from "axios";
import swal from "sweetalert2";

import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { globalState, accessTokenKey, baseUrl } from "../utils/config";

import SingleJob from "./layouts/SingleJob";
import Loader from "./layouts/Loader";

function Search() {

    let timer = null;
    const navigate = useNavigate();
    const urlSearchParams = new URLSearchParams(window.location.search);

    const [jobs, setJobs] = useState([]);
    const [page, setPage] = useState(1);
    const [refetch, setRefetch] = useState(1);
    const [loading, setLoading] = useState(false);

    const [keyword, setKeyword] = useState(urlSearchParams.get("keyword") || "");
    const [category, setCategory] = useState(urlSearchParams.get("category") || "");
    const [location, setLocation] = useState(urlSearchParams.get("location") || "");
    const [filterNature, setFilterNature] = useState(urlSearchParams.get("nature") || "");

    const [categories, setCategories] = useState([]);
    const [locations, setLocations] = useState([]);
    const [types, setTypes] = useState([]);
    const [nature, setNature] = useState([]);

    async function doSearch() {
        setLoading(true);

        try {
            const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
            const form = document.getElementById("form-search");

            const formData = new FormData();
            formData.append("page", page);
            formData.append("time_zone", timeZone);
            formData.append("keyword", keyword);
            formData.append("category", category);
            formData.append("location", location);
            formData.append("salary_from", form.salary_from.value || 0);
            formData.append("salary_to", form.salary_to.value || 0);

            var checked = document.querySelectorAll("#form-search input[name='nature[]']:checked");
            var arr = [];
            for (let a = 0; a < checked.length; a++) {
                arr.push(checked[a].value);
            }
            formData.append("nature", JSON.stringify(arr));

            checked = document.querySelectorAll("#form-search input[name='type[]']:checked");
            arr = [];
            for (let a = 0; a < checked.length; a++) {
                arr.push(checked[a].value);
            }
            formData.append("types", JSON.stringify(arr));

            const response = await axios.post(
                baseUrl + "/api/jobs/search",
                formData,
                {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem(accessTokenKey)
                    }
                }
            );

            if (response.data.status == "success") {
                setJobs(response.data.jobs);
            } else {
                swal.fire("Error", response.data.message, "error");
            }
        } catch (exp) {
            console.log(exp.message);
        } finally {
            setLoading(false);
        }
    }

    function onChangeNature() {
        const checked = document.querySelectorAll("#form-search input[name='nature[]']:checked");
        const arr = [];
        for (let a = 0; a < checked.length; a++) {
            arr.push(checked[a].value);
        }
        setNature(arr);
    }

    function onChangeType() {
        const checked = document.querySelectorAll("#form-search input[name='type[]']:checked");
        const arr = [];
        for (let a = 0; a < checked.length; a++) {
            arr.push(checked[a].value);
        }
        setTypes(arr);
    }

    async function onInit() {
        try {
            const formData = new FormData();
            formData.append("type", "job");

            const response = await axios.post(
                baseUrl + "/api/categories/fetch",
                formData,
                {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem(accessTokenKey)
                    }
                }
            );

            if (response.data.status == "success") {
                setCategories(response.data.categories);
                setLocations(response.data.locations);
            } else {
                // swal.fire("Error", response.data.message, "error");
            }
        } catch (exp) {
            console.log(exp.message);
        }
    }

    useEffect(function () {
        if (refetch > 1) {
            doSearch();
        }
    }, [refetch]);

    useEffect(function () {
        const urlSearchParams = new URLSearchParams(window.location.search);

        const k = urlSearchParams.get("keyword") || "";
        const c = urlSearchParams.get("category") || "";
        const l = urlSearchParams.get("location") || "";
        const n = urlSearchParams.get("nature") || "";
        
        setKeyword(k);
        setCategory(c);
        setLocation(l);

        if (n != "") {
            document.querySelector("#form-search input[name='nature[]'][value='" + n + "']").checked = true;
        }

        onInit();
        doSearch();
    }, []);

    return (
        <>
            <div className="container-xxl py-5 bg-dark page-header mb-5">
                <div className="container my-5 pt-5 pb-4">
                    <h1 className="display-3 text-white mb-3 animated slideInDown">Search</h1>
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb text-uppercase">
                            <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                            <li className="breadcrumb-item text-white active" aria-current="page">Search</li>
                        </ol>
                    </nav>
                </div>
            </div>

            <div className="container-xxl py-5">
                <div className="container">
                    <h1 className="text-center mb-5 wow fadeInUp" data-wow-delay="0.1s">Job Listing</h1>
                    
                    <div className="row">
                        <div className="col-md-3">
                            <div className="card card-body">
                                <form onSubmit={ function (event) {
                                    event.preventDefault();
                                    setRefetch(refetch + 1);
                                } } id="form-search">

                                    <div className="form-floating">
                                        <input type="text" className="form-control" name="keyword"
                                            value={ keyword }
                                            onChange={ function (event) {
                                                setKeyword(event.target.value || "");

                                                /*clearTimeout(timer);
                                                timer = setTimeout(function () {
                                                    setRefetch(refetch + 1);
                                                }, 1000);*/
                                            } } />
                                        <label>Keyword</label>
                                    </div>

                                    <div className="form-floating mt-3">
                                        <select className="form-select border-0" name="category"
                                            value={ category }
                                            onChange={ function (event) {
                                                setCategory(event.target.value || "");
                                                // setRefetch(refetch + 1);
                                            } }>
                                            <option value="">Category</option>

                                            { categories.map(function (cat, index) {
                                                return (
                                                    <option key={ `category-${ index }` }
                                                        value={ cat.category }>{ cat.category }</option>
                                                );
                                            }) }
                                        </select>
                                        <label>Category</label>
                                    </div>

                                    <div className="form-floating mt-3">
                                        <select className="form-select border-0" name="location"
                                            value={ location }
                                            onChange={ function (event) {
                                                setLocation(event.target.value || "");
                                                // setRefetch(refetch + 1);
                                            } }>
                                            <option value="">Location</option>
                                            
                                            { locations.map(function (location, index) {
                                                return (
                                                    <option key={ `location-${ index }` }
                                                        value={ location }>{ location }</option>
                                                );
                                            }) }
                                        </select>
                                        <label>Location</label>
                                    </div>

                                    <div className="ms-2 mt-3">
                                        <label>Type</label>

                                        <div className="mt-1">
                                            <p className="mb-0">
                                                <label>
                                                    <input type="checkbox" name="type[]" value="remote"
                                                        onChange={ function () {
                                                            onChangeType();
                                                        } } />
                                                    &nbsp;Remote
                                                </label>
                                            </p>

                                            <p className="mb-0">
                                                <label>
                                                    <input type="checkbox" name="type[]" value="on_site"
                                                        onChange={ function () {
                                                            onChangeType();
                                                        } } />
                                                    &nbsp;On-site
                                                </label>
                                            </p>

                                            <p className="mb-0">
                                                <label>
                                                    <input type="checkbox" name="type[]" value="hybrid"
                                                        onChange={ function () {
                                                            onChangeType();
                                                        } } />
                                                    &nbsp;Hybrid
                                                </label>
                                            </p>
                                        </div>
                                    </div>

                                    <div className="ms-2 mt-3">
                                        <label>Nature</label>

                                        <div className="mt-1">
                                            <p className="mb-0">
                                                <label>
                                                    <input type="checkbox" name="nature[]" value="full_time"
                                                        onChange={ function () {
                                                            onChangeNature();
                                                        } } />
                                                    &nbsp;Full time
                                                </label>
                                            </p>

                                            <p className="mb-0">
                                                <label>
                                                    <input type="checkbox" name="nature[]" value="part_time"
                                                        onChange={ function () {
                                                            onChangeNature();
                                                        } } />
                                                    &nbsp;Part time
                                                </label>
                                            </p>
                                        </div>
                                    </div>

                                    <div className="ms-2 mt-3">
                                        <label>Salary</label>

                                        <div className="row mt-1">
                                            <div className="col-md-6 pe-1">
                                                <input type="number" min="0" name="salary_from" placeholder="From"
                                                    className="form-control" />
                                            </div>

                                            <div className="col-md-6 ps-1">
                                                <input type="number" min="0" name="salary_to" placeholder="To"
                                                    className="form-control" />
                                            </div>
                                        </div>
                                    </div>

                                    <button type="submit" className="btn btn-primary border-0 w-100 mt-4"
                                        disabled={ loading }>Search</button>
                                </form>
                            </div>
                        </div>

                        <div className="col-md-9">

                            { loading && (
                                <div className="row mb-3">
                                    <div className="col-md-12 text-center">
                                        <Loader />
                                    </div>
                                </div>
                            ) }

                            { (!loading && jobs.length <= 0) && (
                                <p>No jobs found.</p>
                            ) }

                            { jobs.map(function (j, index) {
                                return (
                                    <SingleJob job={ j }
                                        key={ `job-${ j.id }` } />
                                );
                            }) }
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Search;